import Debug from "debug";

const log = Debug("legend");

const urlOpenSans =
  "https://fonts.googleapis.com/css?family=Poppins:wght@400;600;700&family=Roboto&display=swap";

function checkGoogle() {
  const controller = new (<any>window).AbortController();
  const signal = controller.signal;
  setTimeout(controller.abort, 1000);
  return window.fetch(urlOpenSans, { signal }).then(
    res => res.ok,
    err => {
      log("check google access: %o", err);
      return false;
    }
  );
}

function checkGFW() {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", urlOpenSans, true);
    xhr.ontimeout = function() {
      log("The request for " + urlOpenSans + " timed out.");
      resolve(true);
    };
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        resolve(false);
      }
    };
    xhr.timeout = 1000;
    xhr.send(null);
  });
}

export default {
  async beforeCreate() {
    const isBanned = await checkGFW();
    const $link: NodeListOf<HTMLLinkElement> = document.querySelectorAll(
      "link.J_fonts"
    );
    $link.forEach(n => {
      if (isBanned) {
        n.href = n.href.replace(".googleapis.com/", ".loli.net/");
      } else {
        n.href = n.href.replace(".loli.net/", ".googleapis.com/");
      }
      n.rel = "stylesheet";
    });
  }
};
